module.exports = __webpack_public_path__ + "img/bg-img.6e53373a.png";